import React, {useContext} from "react";
import CornersIcon from "views/marketplace/merchandising/nav/icon/CornersIcon";
import NavTree from "views/marketplace/merchandising/nav/navTree";
import {ProductDataContext} from "contexts/productDataContext";

export default function CornersNav(props) {

    const { cornersLoaded, cornersFilters } = useContext(ProductDataContext);
    const topNodeLabel = "merchandising.show.label.nav.corners";
    const topNodeIcon = CornersIcon;

    return (
        <>
            {cornersLoaded && <NavTree 
                items={cornersFilters.tabContent.items}
                topItems={cornersFilters.tabContent.items}
                topNodeLabel={topNodeLabel}
                topNodeIcon={topNodeIcon}
                nodeId={props.nodeId}
                type={'Corner'}
                {...props}
            />}
        </>
    );
}
